'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# JobBoardSVG
An SVG Case Maker icon
 */
var JobBoardSVG = function JobBoardSVG(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width;
  return _react2.default.createElement(
    'svg',
    {
      'aria-label': 'Job Board',
      role: 'img',
      height: height || undefined,
      width: width || undefined,
      viewBox: '0 0 650 568.75',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement(
      'g',
      { id: 'jobboard', fill: color, fillRule: 'nonzero' },
      _react2.default.createElement('path', { d: 'M650,182.81 V284.38 H0 V182.81 c0-32.5,28.43-60.93,60.94-60.93 H162.5 V60.94 C162.5,28.43,190.93,0,223.44,0 H426.56 c32.51,0,60.94,28.43,60.94,60.94 v60.94 H589.06 C621.57,121.88,650,150.31,650,182.81 Z' }),
      _react2.default.createElement('path', { d: 'M406.25,325 H650 V507.81 c0,32.51-28.43,60.94-60.94,60.94 H60.94 C28.43,568.75,0,540.32,0,507.81 V325 H243.75 v60.94 a20.32,20.32,0,0,0,20.31,20.31 H385.94 a20.32,20.32,0,0,0,20.31-20.31 Z m0-243.75 H243.75 v40.63 h162.5 Z' })
    )
  );
};

JobBoardSVG.propTypes = {
  /** a color for the icon */
  color: _propTypes2.default.string,
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string
};

JobBoardSVG.displayName = 'JobBoardSVG';

exports.default = JobBoardSVG;
JobBoardSVG.__docgenInfo = {
  'description': '# JobBoardSVG\r\nAn SVG Case Maker icon',
  'methods': [],
  'displayName': 'JobBoardSVG',
  'props': {
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    },
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    }
  }
};